<!-- @format -->
<template>
	<div class="pcp-mo-list-menu">
		<!-- <van-nav-bar
			v-if="menuDirHistory.length > 1"
			:title="curMenu.name"
			left-text="返回"
			left-arrow
			@click-left="onClickBack"
		/> -->

		<template v-for="item1 in curMenuTree" :key="item1.id">
			<div v-if="item1.name" class="group-title">{{ item1.name }}</div>
			<div class="toolbar">
				<van-list :loading="false" :finished="true" finished-text="">
					<template v-for="item in item1.children">
						<template v-if="item.alias.indexOf('-showmenuitem-user-p-builtin') > -1">
							<pcp-mo-user-item :key="item.id" :item="item" />
						</template>
						<template v-else>
							<van-cell :key="item.id" :title="`${item.name}`" value="" is-link @click="onClickMenuItem(item)">
								<template #icon>
									<div class="cell-icon">
										<van-image :src="getFilePreviewUrlById(item.appIcon)" />
									</div>
								</template>
							</van-cell>
						</template>
					</template>
				</van-list>
			</div>
		</template>
	</div>
</template>

<script lang="ts" setup>
	import { queryStringToObject } from '@power/utils';
	import { MenuItem, getFilePreviewUrlById } from '@power/runtime-vue3';
	import { onClickMenuItem as onClickMenuItem2 } from './index';
	import { useMenuStore } from '@/store/modules/menu';
	import { useMoGlobalStoreWithOut } from '@/store/modules/moglobal';
	import PcpMoUserItem from '@/p-components/mobile/pcp-mo-user-item/index.vue';
	const moglobalStore = useMoGlobalStoreWithOut();
	const menuStore = useMenuStore();
	const route = useRoute();
	const router = useRouter();

	interface Props {
		menus?: Array<MenuItem>; // 所有菜单
		rootMenu: MenuItem; // 根菜单 只展示这个菜单以下的内容
	}
	const props = withDefaults(defineProps<Props>(), {});
	const menus = ref(props.menus || menuStore.menusRes);

	const curMenu = ref(props.rootMenu);

	const curMenuTree = ref<Array<MenuItem>>([]);
	const menuDirHistory = ref<Array<string>>([]);

	const onClickBack = async () => {
		menuDirHistory.value.pop();
		const curMenuId = menuDirHistory.value[menuDirHistory.value.length - 1];
		await initMenus({
			curMenuId,
		});
	};
	const init = async (params) => {
		menuDirHistory.value = [];
		await clickMenuItemDir(params);
	};
	const initMenus = async (params) => {
		const { curMenuId } = params;
		setCurMenus(curMenuId);
	};
	const setCurMenus = (menuId) => {
		curMenu.value = menus.value.filter((item) => {
			const {
				id,
				// parentId,
				// name,
				// alias,
				// resourceType,
				// isFolder,
				// defaultUrl,
				// displayInMenu,
				// systemId,
				// sysType,
				// appIcon,
			} = item;
			return id === menuId;
		})[0] || { name: '工作台', id: 'id', alias: '' };
		const curMenusDir = menus.value.filter((item) => {
			const {
				parentId,
				resourceType,
				// id,
				// name,
				// alias,
				// isFolder,
				// defaultUrl,
				// displayInMenu,
				// systemId,
				// sysType,
				// appIcon,
			} = item;
			return parentId === menuId && 'dir' === resourceType;
		});
		const curMenusMenu = menus.value.filter((item) => {
			const {
				parentId,
				resourceType,
				// id,
				// name,
				// alias,
				// isFolder,
				// defaultUrl,
				// displayInMenu,
				// systemId,
				// sysType,
				// appIcon,
			} = item;
			return parentId === menuId && 'menu' === resourceType;
		});
		const curMenuTreeTmp = curMenusDir.map((item) => {
			const menuId = item.id;
			const children = menus.value.filter((item) => {
				const {
					parentId,
					// id,
					// name,
					// alias,
					// resourceType,
					// isFolder,
					// defaultUrl,
					// displayInMenu,
					// systemId,
					// sysType,
					// appIcon,
				} = item;
				return parentId === menuId;
			});
			return {
				...item,
				children,
			};
		});
		if (curMenusMenu && curMenusMenu.length > 0) {
			curMenuTree.value = [{ name: '', id: '', alias: '', children: curMenusMenu }].concat(curMenuTreeTmp);
		} else {
			curMenuTree.value = curMenuTreeTmp;
		}
		const { name } = curMenu.value;
		if (menuDirHistory.value.length > 1) {
			moglobalStore.setNavigationBar({
				title: name,
				leftArrow: true,
				onClickBack,
			});
		} else {
			moglobalStore.setNavigationBar({
				title: name,
				leftArrow: false,
			});
		}
	};
	const onClickMenuItem = (item) => {
		// console.log('item', item);
		// const { parentId, id, name, alias, resourceType, isFolder, defaultUrl, displayInMenu, systemId, sysType, appIcon } =
		//   item;
		const { id, resourceType } = item;

		if (resourceType === 'menu') {
			clickMenuItem(item);
		} else {
			clickMenuItemDir({ ...item, curMenuId: id });
		}
		return;
	};
	const clickMenuItem = (item) => {
		const url = onClickMenuItem2(item);
		const arr = url?.split('?') || [];
		const query = queryStringToObject(arr[1] || '');
		const path = arr[0];

		router.push({
			path,
			query: {
				...query,
				navigationBarTitle: item.name,
			},
		});
		moglobalStore.setNavigationBar({
			title: item.name,
			leftArrow: true,
		});
		return;
	};
	const clickMenuItemDir = async (params) => {
		const { curMenuId } = params;
		menuDirHistory.value.push(curMenuId);
		await initMenus({
			curMenuId,
		});
	};

	const refresh = () => {
		menus.value = props.menus || menuStore.menusRes;
		curMenu.value = props.rootMenu;
		const curMenuId = props.rootMenu?.id || route.query.id;
		init({
			curMenuId,
		});
	};
	refresh();
	watch([() => props.rootMenu, () => props.menus], () => {
		refresh();
	});
	watch([() => route.query.id], () => {
		if (route.query.id && route.query.id != props.rootMenu?.id) {
			refresh();
		}
	});
</script>

<style scoped lang="scss">
	.group-title {
		font-size: 16px;
		font-weight: bold;
		color: #333333;
		padding: 15px 30px;
	}

	.pcp-mo-swipe .van-swipe-item {
		color: #fff;
		font-size: 20px;
		line-height: 150px;
		text-align: center;
		background-color: #39a9ed;
	}

	.cell-icon {
		display: flex;
		align-items: center;
		margin-right: 6px;

		.van-image {
			width: 18px;
			height: 18px;
		}
	}

	.user-icon {
		display: flex;
		align-items: center;
		margin-right: 6px;

		.van-image {
			width: 46px;
			height: 46px;
		}
	}

	.van-image {
		width: 50px;
		height: 50px;
	}
</style>
